import React, { useState, useMemo, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer
} from '../../CreateEvent/style';
import { FormHeading } from '../../ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { RecognitionCloseIcon } from '../../../utils/icons';
import { ManagerIconContainer } from '../../Manager/styles';
import PropTypes from 'prop-types';
import { ContainerMain } from '../../common/commonStyles';
import CommonModal from '../../common/CommonModal/CommonModal';
import { GetCompanyAdminRewardTier, GetCompanyAdminRewardTierConfig } from '../../../redux/constants/apiConstants';
import { capitalizeText, fetchApi, getEndDateAfter12Months } from '../../../utils/methods';
import MonthRangeModal from './MonthRangeModal';
import ConfirmPlanModal from './ConfirmPlanModal';
import SkeletonLoder from '../../common/skeletonLoder';
import dayjs from 'dayjs';

const plans = {
  custom:{
    id: 'custom',
    title: 'Build Your Own',
    badge: 'Custom',
    description: 'Set your own point goals and thresholds.',
    buttonText: 'Set Custom Levels',
    headingBg:'linear-gradient(90deg, rgba(218, 218, 174, 0.60) 0%,rgba(197, 195, 127, 0.60) 100%)',
    tierBg:'#A49A4E'
  },

  recommended:{
    id: 'recommended',
    title: 'Recommended',
    badge: 'Standard',
    description: 'Balanced progression that works for most teams.',
    buttonText: 'Use Recommended',
    headingBg:'linear-gradient(90deg, rgba(231, 238, 248, 0.60) 0%,rgba(185, 200, 232, 0.60) 100%)',
    tierBg:'#8391D1'
  },
    
  boost:{
    id: 'boost',
    title: 'Boost Engagement',
    badge: 'Accelerated',
    description: 'Faster rewards to drive participation and momentum.',
    buttonText: 'Use Boost Engagement',
    headingBg:'linear-gradient(90deg, rgba(238, 220, 230, 0.60) 0%,rgba(206, 152, 179, 0.60) 100%)',
    tierBg:'#A65C7C'
  },
}

const ManageRewardsTiers = ({history,companyInfo}) => {
  const [values, setValues] = useState({
    Bronze: '',
    Silver: '',
    Gold: '',
    Platinum: ''
  });

  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showMonthRangeModal, setShowMonthRangeModal] = useState(false);
  const[showPlanConfirmModal,setShowPlanConfirmModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [tierConfigDetails, setTierConfigDetails] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState('custom');
  const[selectedStartMonth, setSelectedStartMonth] = useState(false);
  const[selectedEndMonth, setSelectedEndMonth] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState(null);
  const[showWarningPopup,setShowWarningPopup] = useState(false);

  const locationState = history?.location?.state;
  const tierConfig = locationState?.tierConfig; //'new',existing

  useEffect(() => {
    fetchCompanyCompanyTierConfigDetails();
    if(locationState?.isEdit){
      fetchCompanyRewardDetails(locationState?.rewardPeriodId)
    }
  }, []);

  const fetchCompanyCompanyTierConfigDetails = async() =>{
    // setLoading(true);

    const tierConfigType = tierConfig === 'new' ? 0 : 1
    try {
      const companyRewardsData = await fetchApi(GetCompanyAdminRewardTierConfig+'?company_id='+ companyInfo.id +  `&future=${tierConfigType}` , "GET");
      if(companyRewardsData.status === 'success'){
        setTierConfigDetails(companyRewardsData.data);
      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      // setLoading(false);
    }
  }

  const fetchCompanyRewardDetails = async(rewardPeriodId) =>{
    setLoading(true);
    try {

      const companyRewardsData = await fetchApi(GetCompanyAdminRewardTier+'?company_id='+ companyInfo.id + (rewardPeriodId ? `&reward_period_id=${rewardPeriodId}`:''), "GET");
      if(companyRewardsData.status === 'success'){
        // setCompanyRewardDetails(companyRewardsData.data);
        const data = companyRewardsData?.data?.tiers?.[0];
        setEditData(data)

        if (!data) return;
  
        /* -------- set tier points -------- */
  
        const tierValues = {};
        data?.tiers?.forEach((tier) => {
          tierValues[tier.tier_name] = tier.tier_points;
        });

        window.console.log("tierValues",tierValues)
  
        setValues(tierValues);
  
        /* -------- set plan -------- */
  
        setSelectedPlan(data?.tier_type || "custom");
  
        /* -------- set start/end month -------- */
  
        setSelectedStartMonth({
          firstDate: data?.start_date,
          month:dayjs(data?.start_date).format("MMMM D, YYYY")
        });
  
        setSelectedEndMonth({
          firstDate: data?.end_date,
          month:dayjs(data?.end_date).format("MMMM D, YYYY")
        });
      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }
  

  const checkIfMatchesAnyLevel = () => {
    const tierLevels = tierConfigDetails?.tier_levels;
  
    if (!tierLevels) return "custom";
  
    const entered = {
      Bronze: Number(values.Bronze),
      Silver: Number(values.Silver),
      Gold: Number(values.Gold),
      Platinum: Number(values.Platinum),
    };
  
    // Helper: compare two tier objects safely
    const isSameLevel = (levelObj) => {
      if (!levelObj) return false;
  
      return (
        Number(levelObj.Bronze) === entered.Bronze &&
        Number(levelObj.Silver) === entered.Silver &&
        Number(levelObj.Gold) === entered.Gold &&
        Number(levelObj.Platinum) === entered.Platinum
      );
    };
  
    // Loop dynamically through all available levels
    for (const [levelName, levelValues] of Object.entries(tierLevels)) {
      if (isSameLevel(levelValues)) {
        setSelectedPlan(levelName);
        return levelName; // recommended / boost / future levels
      }
    }
    setSelectedPlan("custom")
    return "custom";
  };
  

  const handleChange = (key, value) => {
    if (!/^\d*$/.test(value)) return; // allow only numbers
    setValues((prev) => {
      const updated = { ...prev, [key]: value };
      validateFields(updated);
      return updated;
    });
  };

  const isValid = useMemo(() => {
    const { Bronze, Silver, Gold, Platinum } = values;

    if (!Bronze || !Silver || !Gold || !Platinum) return false;

    return (
      Number(Silver) > Number(Bronze) &&
      Number(Gold) > Number(Silver) &&
      Number(Platinum) > Number(Gold)
    );
  }, [values]);

  const handleSubmit = () => {
    if(values > 2000){
      setShowWarningPopup(true);
      return;
    }
    if (!isValid) {
      toast.error('Each reward cap must be greater than the previous tier');
      return;
    }

    const matchedLevel = checkIfMatchesAnyLevel();

    if (matchedLevel === "recommended" || matchedLevel === "boost") {
      setShowConfirmPopup(true);
      return;
    }

    setShowMonthRangeModal(true)
  };

  const onMonthChange = (item)=>{
  //   window.console.log("item",item);
    setSelectedStartMonth(item);
    const endDate = getEndDateAfter12Months(item?.firstDate)
    setSelectedEndMonth(endDate)
  }

  const renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={()=>history.goBack()}>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
      </div>
      {"Manage Rewards Bucket Caps"}
    </FormHeading>
  );

  const validateFields = (updatedValues) => {
    const { Bronze, Silver, Gold, Platinum } = updatedValues;
    const newErrors = {};
  
    if (Silver && Bronze && Number(Silver) <= Number(Bronze)) {
      newErrors.Silver = true;
    }
  
    if (Gold && Silver && Number(Gold) <= Number(Silver)) {
      newErrors.Gold = true;
    }
  
    if (Platinum && Gold && Number(Platinum) <= Number(Gold)) {
      newErrors.Platinum = true;
    }
  
    setErrors(newErrors); // 🔥 replace completely
  };

  if (loading) {
    return (
      <ContainerMain>
        <div className='top-cards'>
          {Array.from({ length: 4 }).map((_, index) => (
            <SkeletonLoder
              key={index}
              width="292px"
              height="190px"
              style={{ gap: "25px" }}
            />
          ))}
        </div>
      </ContainerMain>
    );
  }
  

  return (
    <>
      <ContainerMain>
        <div className='content-wrap'>
          {renderHeading()}
          <Container height="100%" stepBackground="#FFFFFF" color="#184A61">
            <div className="form" style={{width:'100%', marginLeft:"0" ,padding:'12px'}}> 
              <div className="formBody">
          
                {[
                  { key: 'Bronze', label: 'Bronze Badge' },
                  { key: 'Silver', label: 'Silver Badge' },
                  { key: 'Gold', label: 'Gold Badge' },
                  { key: 'Platinum', label: 'Platinum Badge' }
                ].map(({ key, label }) => (
                  <InputContainer key={key}>
                    <StyledLabel isFont="16px" color="#184A61" margin={key === 'Bronze' && '0px'}>
                      {label} <span>*</span>
                    </StyledLabel> 
          
                    <StyledInputV2
                      placeholder={`Enter Custom Point Value`}
                      value={values[key]}
                      onChange={(e) => handleChange(key, e.target.value)}
                      bgColor="white"
                      border="1px solid #BDBDBD"
                      color="#184A61"
                    />
                    {errors[key] && (
                      <StyledLabel
                        isFont="12px"
                        color="#DA6C74"
                        style={{ marginTop: "6px" }}
                      >
                        Points must be entered greater than above level
                      </StyledLabel>)}
                  </InputContainer>
                ))}
              </div>
            </div>
          </Container>
        </div>
      </ContainerMain>

      <ButtonContainer>
        <div className="wrapper">
          <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" 
            disabled={!isValid}
            onClick={handleSubmit}
          >
             Done
          </CommonButtonPopup>
        </div>
      </ButtonContainer>
      {showConfirmPopup && <CommonModal
        show={showConfirmPopup}
        //  icon={RecognitionWarningIcon("#CE7841")}
        title="Points Setup"
        description={`The Points Set By You Are Same As Our ${capitalizeText(selectedPlan)} Plan It Will Be Considered As Recommended Plan Not As Custom Plan!`}
        descriptionColor="#CE7841"
        subDescription="Are You Sure You Want To Move Forward With These Plan?"
        onCancel={()=>setShowConfirmPopup(false)}
        onConfirm={() =>{setShowMonthRangeModal(true); setShowConfirmPopup(false)}}
        cancelText="Change"
        confirmButtonText="Go With It!"
        //  buttonIcon={ExitChallenge("white")}
        confirmButtonWidth="198px"
        modalHeight="auto"
        isFontSize="16px"
      />
      }

      {showWarningPopup && <CommonModal
        show={showWarningPopup}
        //  icon={RecognitionWarningIcon("#CE7841")}
        title="Alert Message"
        description={`Are you sure you want to launch 20,000+ points levels for your users`}
        descriptionColor="#CE7841"
        subDescription="Contact to our support team for launching your company badge points"
        onCancel={()=>setShowWarningPopup(false)}
        onConfirm={() =>{setShowMonthRangeModal(true); setShowConfirmPopup(false)}}
        cancelText="Change"
        confirmButtonText="Go With It!"
        //  buttonIcon={ExitChallenge("white")}
        confirmButtonWidth="198px"
        modalHeight="auto"
        isFontSize="16px"
      />
      }

      {showMonthRangeModal && <MonthRangeModal show={showMonthRangeModal} title={'Select Month Range'} tierConfig={tierConfig} selectedStartMonth={selectedStartMonth} selectedEndMonth={selectedEndMonth} onMonthChange={onMonthChange} onCancel={()=>setShowMonthRangeModal(false)} onConfirm={() =>{setShowPlanConfirmModal(true);setShowMonthRangeModal(false)}} tierConfigDetails={tierConfigDetails}/>}
      {showPlanConfirmModal && <ConfirmPlanModal show={showPlanConfirmModal} title={'Confirm Your Plan'} tierConfig={tierConfig} selectedStartMonth={selectedStartMonth} selectedEndMonth={selectedEndMonth} selectedPlan={plans[selectedPlan]} points={values} onCancel={()=>setShowPlanConfirmModal(false)} companyInfo={companyInfo} screen={'custom'} history={history} editData={editData}/>}
    </>
  );
};

ManageRewardsTiers.propTypes = {
  history: PropTypes.object.isRequired,
  companyInfo:PropTypes.object
} 

export default ManageRewardsTiers;
